import DatePicker from './DatePicker';

export default DatePicker;
export const { DateRangePicker, DayPickerRangeController } = DatePicker;
